// ─── AR Reconciliation – Access & Hospital helpers ─────────────────────────────
// Centralised so both the Header tab and the page route-guard stay in sync.

// Role that grants access to AR Reconciliation.
export const AR_ACCESS_ROLE = 'ar_dash';

// TEMP: users (matched by email) that should always get AR access + a hardcoded
// hospital until their real roles / HospitalIds are provisioned. Remove once the
// backend is ready.
const TEMP_WHITELIST_EMAILS = ['sunny.sen@pristyncare.com'];
const TEMP_FALLBACK_HOSPITAL_IDS = ['GDunfdR4GA', 'X8nBAtLR3H', 'Nv5CAnnU35'];

const normalize = (v) => (v == null ? '' : String(v).trim().toLowerCase());

const getUserEmail = (user) => normalize(user?.email || user?.emailId || user?.Email);

const isWhitelisted = (user) => TEMP_WHITELIST_EMAILS.includes(getUserEmail(user));

/**
 * True when the user may access AR Reconciliation.
 * Checks roles.role and roles.otherRoles (case-insensitive) for `ar_dash`.
 */
export function hasArAccess(user) {
  if (!user) return false;

  // TEMP whitelist bypass (by email)
  if (isWhitelisted(user)) return true;

  const target = AR_ACCESS_ROLE.toLowerCase();
  const role = normalize(user?.roles?.role);
  if (role === target) return true;

  const otherRoles = user?.roles?.otherRoles;
  if (Array.isArray(otherRoles)) {
    return otherRoles.some((r) => normalize(r) === target);
  }
  return false;
}

/**
 * Returns the user's hospital ids as a clean array of strings.
 * `HospitalIds` may be a single string or an array. Falls back to the TEMP
 * hardcoded id for whitelisted users when nothing is assigned.
 */
export function getUserHospitalIds(user) {
  const raw = user?.HospitalIds;
  let ids = [];

  if (Array.isArray(raw)) {
    ids = raw;
  } else if (raw != null && String(raw).trim() !== '') {
    ids = [raw];
  }

  ids = ids.map((id) => String(id).trim()).filter(Boolean);

  // TEMP: give whitelisted users (by email) a working hospital id if none assigned
  if (ids.length === 0 && isWhitelisted(user)) {
    return [...TEMP_FALLBACK_HOSPITAL_IDS];
  }

  return ids;
}
